module.exports = __webpack_public_path__ + "media/src/assets/Images/AddIcon-336c4fef644b23560578862075219154.svg";